import { getFormatMessage } from '@/utils/utils'
import { Modal } from 'antd'
import React, { useState } from 'react'
import { TemplateEdit } from '.'
import { TemplateEditModalProps } from '../interface'

export const TemplateEditModal: React.FC<TemplateEditModalProps> = (
  props: TemplateEditModalProps
) => {
  const formatMessage = getFormatMessage()
  const { visible, editItem, onVisibleChange, onSave } = props
  const [formResult, setFormResult] = useState<boolean>(false)

  const title =
    editItem && editItem.id
      ? formatMessage({
          id: 'app.template.edit.title',
          parameters: { name: editItem?.name }
        })
      : formatMessage({ id: 'app.template.edit.title.create' })

  const handleFormValidate = (ok: boolean) => {
    setFormResult(false)
    if (ok) {
      onVisibleChange?.(false)
    }
  }

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={() => onVisibleChange?.(false)}
      onOk={() => setFormResult(true)}
      okText={formatMessage({ id: 'app.modal.ok' })}
      cancelText={formatMessage({ id: 'app.modal.cancel' })}
      width={500}
      maskClosable={false}
      destroyOnClose={true}
    >
      <TemplateEdit
        item={editItem}
        formResult={formResult}
        onFormValidate={handleFormValidate}
        onFormSubmit={onSave}
      />
    </Modal>
  )
}
